import React from "react";
import { Link } from "react-router-dom";
import { ACTIVE, SYSTEM_ADMIN_TABS } from "constants/systemAdmin";
import {
  SYSTEM_ADMIN_LICENSE,
  SYSTEM_ADMIN_WORKSPACES,
  SYSTEM_ADMIN_SECURITY,
  SYSTEM_ADMIN_USERS,
} from "constants/routes";
import { useSelector } from "react-redux";

const SystemAdminTabs = () => {
  const active = useSelector((state) => state.systemAdmin.tabActive);

  return (
    <div className="system_admin__tabs" data-testid={SYSTEM_ADMIN_TABS}>
      <Link
        to={SYSTEM_ADMIN_WORKSPACES}
        className={`${active === 0 ? ACTIVE : ""}`}
      >
        <div className="system_admin__tabs__workspaces">
          <span>Workspaces</span>
        </div>
      </Link>
      <Link to={SYSTEM_ADMIN_USERS} className={`${active === 1 ? ACTIVE : ""}`}>
        <div className="system_admin__tabs__users">
          <span>Users</span>
        </div>
      </Link>
      <Link
        to={SYSTEM_ADMIN_LICENSE}
        className={`${active === 2 ? ACTIVE : ""}`}
      >
        <div className="system_admin__tabs__license">
          <span>License</span>
        </div>
      </Link>
      <Link
        to={SYSTEM_ADMIN_SECURITY}
        className={`${active === 3 ? ACTIVE : ""}`}
      >
        <div className="system_admin__tabs__security">
          <span>Security</span>
        </div>
      </Link>
    </div>
  );
};

export default SystemAdminTabs;
